export default __webpack_public_path__ + "static/media/branding-blackitalic-webfont.ad976c35.woff2";